import {connect} from "react-redux";
import {SetSort, setSort, FetchContracts, fetchContracts, FirstPage, firstPage} from "../actions";
import * as selectors from "../selectors";
import * as React from "react";
import Props = require("react");
import {notClickableFields, SortableField} from "../models/SortableFieldEnum";
import ContractlistState from "../ContractlistState";

interface TagProps {
    field: SortableField
}

interface StateProps {
    sortByField: string,
    isAscending: boolean,
    showArchivedContracts: boolean,
    showOtherPeoplesContracts: boolean,
    typeFilter: string,
    searchString: string,
    page: number
}

interface DispatchProps {
    doSetSort: SetSort,
    doFetchContracts: FetchContracts,
    doFirstPage: FirstPage
}

const mapStateToProps = (state: ContractlistState): StateProps => {
    return {
        sortByField: selectors.sortByField(state),
        isAscending: selectors.isAscending(state),
        showArchivedContracts: selectors.showArchivedContracts(state),
        typeFilter: selectors.typeFilter(state),
        searchString: selectors.stateSearchString(state),
        showOtherPeoplesContracts: selectors.showOtherPeoplesContracts(state),
        page: selectors.page(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetSort: setSort,
    doFetchContracts: fetchContracts,
    doFirstPage: firstPage
});

type Props = TagProps & StateProps & DispatchProps;

class SortHeaderComponent extends React.Component<Props, {}> {

    render() {

        const {field, isAscending, sortByField} = this.props;

        const isClickable = !notClickableFields.includes(field.value);
        const isSorted = field.value === sortByField;
        return (
            <th
                className={(isClickable ? "clickable sortable" : "") + (isSorted ? " sorted" : "")}
                onClick={isClickable ? () => this.handleSorting(field.value) : null}>
                <div className={"flex"}>
                    <div className={"title"}> {field.name}</div>
                    <div className={"icon"}>
                        {isSorted &&
                        <span className={"glyphicon " + (isAscending ? "glyphicon-chevron-down" : "glyphicon-chevron-up")}/>
                        }
                    </div>
                </div>
            </th>
        );
    }

    handleSorting = function(field: string) {
        this.props.doSetSort(field);
        this.props.doFirstPage();
        let isAscending = this.props.isAscending;
        let sortByField = this.props.sortByField;
        if (sortByField == field) {
            this.fetchContracts(this.props.showArchivedContracts, this.props.typeFilter, this.props.searchString, this.props.showOtherPeoplesContracts, field, !isAscending);
        }
        else {
            this.fetchContracts(this.props.showArchivedContracts, this.props.typeFilter, this.props.searchString, this.props.showOtherPeoplesContracts, field, true);
        }
    }

    fetchContracts = function (showArchivedContracts: boolean, typeFilter: String, searchString: String, showOtherPeoplesContracts: boolean, sortByField: String, isAscending: boolean) {
        this.props.doFetchContracts(1, showArchivedContracts, typeFilter, searchString, showOtherPeoplesContracts, true, sortByField, isAscending, false);
    }
}

export const SortHeader = connect(mapStateToProps, mapDispatchToProps)(SortHeaderComponent);

